export default {
    SERVER_BASE_URL: '',
    BaiduMap: {
        ak: process.env["VUE_APP_BAIDU_MAP_AK"] || '4l3hxBWTjCkq7CXtMgjFg8C6M49zjKXf',     //百度地图AK
        styleId: process.env["VUE_APP_BAIDU_MAP_STYLE_ID"] || '0f582613784aea66b0d272b5e0b34abf', //百度地图样式ID
        center: [120.30565557161933, 31.547000226020288],  //地图中心点
    },
}



// WEBPACK FOOTER //
// ./src/utils/constant.js